export default __webpack_public_path__ + "static/media/gallery_07.81b5ac25.jpg";